import { FieldDefinition } from "../../../../component/form/field-definition";

export const studentUpdateFieldDefinitions: FieldDefinition[] = [
    {
        id: "workingBadgePath",
        name: "Badge path",
        type: "text",
        required: true,
        disabled: false
    },
    {
        id: "comment",
        name: "Add comment",
        type: "text",
        required: false,
        disabled: false
    }
];